import {HandleSubmit} from '../../func/HandleSubmit';

async function DeleteUser(user_name) {
    const SendParameters = {
        detail: {
            user_name: user_name,
        }
    };
    console.log("SendParameters",SendParameters);
    var response_info = await HandleSubmit('user/delete', SendParameters);
    console.log("res1",response_info);
    if (response_info.status.trim() === "OK") {
        alert("حذف گردید");
    }
    else {
        alert("مشکل در حذف");
    }
}
export default (DeleteUser);




// WEBPACK FOOTER //
// ./src/pages/User/DeleteUser.js